// This is a lookup map consumed by `createSpec`, not an entry point re-exporting the schema
/* eslint-disable @atlaskit/editor/no-re-export */
import {
	alignment,
	annotation,
	backgroundColor,
	blockCard,
	blockRootOnly,
	blockTaskItem,
	block_content,
	blockquote,
	bodiedExtension,
	bodiedExtension_root_only,
	bodiedExtension_with_marks,
	bodiedSyncBlock,
	border,
	breakout,
	bulletList,
	caption,
	code,
	codeBlock,
	codeBlock_root_only,
	confluenceInlineComment,
	dataConsumer,
	date,
	decisionItem,
	decisionList,
	doc,
	em,
	embedCard,
	emoji,
	expand,
	expand_root_only,
	extension,
	extensionFrame,
	extension_root_only,
	extension_with_marks,
	fontSize,
	fragment,
	hardBreak,
	heading,
	heading_with_alignment,
	heading_with_indentation,
	heading_with_no_marks,
	indentation,
	inlineCard,
	inlineExtension,
	inlineExtension_with_marks,
	inline_content,
	layoutColumn,
	layoutSection,
	layoutSection_full,
	layoutSection_with_single_column,
	link,
	listItem,
	media,
	mediaGroup,
	mediaInline,
	mediaSingle,
	mediaSingle_caption,
	mediaSingle_full,
	mention,
	multiBodiedExtension,
	multiBodiedExtension_root_only,
	nestedExpand,
	nestedExpand_content,
	nestedExpand_with_no_marks,
	non_nestable_block_content,
	orderedList,
	panel,
	panel_root_only,
	paragraph,
	paragraph_with_alignment,
	paragraph_with_font_size,
	paragraph_with_indentation,
	paragraph_with_no_marks,
	placeholder,
	rule,
	rule_root_only,
	status,
	strike,
	strong,
	subsup,
	syncBlock,
	table,
	tableCell,
	tableHeader,
	tableRow,
	taskItem,
	taskList,
	text,
	textColor,
	text_code_inline,
	text_formatted,
	text_link_inline,
	text_with_no_marks,
	underline,
} from '@atlaskit/adf-schema/schema-validator';

/**
 * The curated set of validator specs consumed by `createSpec`.
 *
 * Deliberately narrower than the full `@atlaskit/adf-schema/schema-validator` export surface:
 * specs absent from this map (e.g. `mediaSingle_width_type`) are not validated by ADF utils.
 */
export const specs: Record<string, unknown> = {
	alignment,
	annotation,
	backgroundColor,
	blockCard,
	blockRootOnly,
	blockTaskItem,
	block_content,
	blockquote,
	bodiedExtension,
	bodiedExtension_root_only,
	bodiedExtension_with_marks,
	bodiedSyncBlock,
	border,
	breakout,
	bulletList,
	caption,
	code,
	codeBlock,
	codeBlock_root_only,
	confluenceInlineComment,
	dataConsumer,
	date,
	decisionItem,
	decisionList,
	doc,
	em,
	embedCard,
	emoji,
	expand,
	expand_root_only,
	extension,
	extensionFrame,
	extension_root_only,
	extension_with_marks,
	fontSize,
	fragment,
	hardBreak,
	heading,
	heading_with_alignment,
	heading_with_indentation,
	heading_with_no_marks,
	indentation,
	inlineCard,
	inlineExtension,
	inlineExtension_with_marks,
	inline_content,
	layoutColumn,
	layoutSection,
	layoutSection_full,
	layoutSection_with_single_column,
	link,
	listItem,
	media,
	mediaGroup,
	mediaInline,
	mediaSingle,
	mediaSingle_caption,
	mediaSingle_full,
	mention,
	multiBodiedExtension,
	multiBodiedExtension_root_only,
	nestedExpand,
	nestedExpand_content,
	nestedExpand_with_no_marks,
	non_nestable_block_content,
	orderedList,
	panel,
	panel_root_only,
	paragraph,
	paragraph_with_alignment,
	paragraph_with_font_size,
	paragraph_with_indentation,
	paragraph_with_no_marks,
	placeholder,
	rule,
	rule_root_only,
	status,
	strike,
	strong,
	subsup,
	syncBlock,
	table,
	tableCell,
	tableHeader,
	tableRow,
	taskItem,
	taskList,
	text,
	textColor,
	text_code_inline,
	text_formatted,
	text_link_inline,
	text_with_no_marks,
	underline,
};
